const localization = new Array();
localization['toggle.menu'] = 'Toggle menu';
localization['label.cleditorControls'] =
'Insert your comment. Press Alt+S to submit your comment or Alt+` to discard it.';
localization['label.closeDialog'] = 'Close dialog';
localization['index.term'] = 'index term';
localization['index.terms.alphabet'] = 'Index terms alphabet';
localization['index.terms.for.letter'] = 'Index terms group for letter';
localization['expand'] = 'Expand';
localization['collapse'] = 'Collapse';
localization['search.query'] = 'Search query';
localization['jump.to.results'] = 'Jump to search results';
localization['jump.to.index'] = 'Jump to index list';
localization['jump.to.content'] = 'Jump to main content';
localization['next.page'] = 'Next';
localization['prev.page'] = 'Previous';
localization['on_this_page'] = 'On this page';
localization['more'] = 'more';
localization['expandSections'] = 'Expand sections';
localization['collapseSections'] = 'Collapse sections';
localization['toggleHighlights'] = 'Toggle search highlights';
localization['Similar results'] = 'Similar results';
localization['Output generated by'] = 'Generated by';
localization['Page'] = 'Page';
localization['Results for:'] = 'document(s) found for';
localization['no_results_only_stop_words1'] =
'No results were found because the search query only contains <span>stop words</span> that are excluded by the search engine.';
localization['no_results_only_stop_words2'] =
'Stop words are very common words or adjectives that hinder search efforts. Words such as: \'of \' , \'the\', \'by\', etc.';
localization['missing'] = 'Missing';
localization['label.home'] = 'Home';
localization['webhelp.search'] = 'Search';
localization['webhelp.index'] = 'Index';
localization['webhelp.index.aria.label'] = 'Go to index terms page';
localization['label.shareFrom'] =
'If you already have an user account for any of the following products, you can use that account to login.';
localization['label.unconfirmedUsers'] = 'Unconfirmed Users';
localization['label.cleanUsers'] = 'Delete Pending Users';
localization['label.tc.userName'] = 'User';
localization['label.tc.name'] = 'Name';
localization['label.tc.email'] = 'E-mail';
localization['label.invertSel'] = 'Invert Selection';
localization['label.invalidPosts'] = 'Invalid pages for posts';
localization['label.cleanComments'] = 'Delete Orphaned Comments';
localization['label.cleanCommentsTooltip'] = 'Delete comments associated with topics that are no longer available';
localization['label.cleanUsersTooltip'] = 'Delete unconfirmed users older than 7 days';
localization['label.viewAllPostsTooltip'] =
'Select the appropriate product / version for which you need comments to be displayed';
localization['label.exportTooltip'] =
'Select the appropriate product / version for which you need comments to be exported to XML format';
localization['label.setVersionTooltip'] =
'Comments will be available only for the product versions starting from the selected one.';
localization['label.fbUnavailable'] =
'The feedback system is disabled! Please contact the WebHelp system administrator.';
localization['label.removeInst'] =
'The folder containing the installation scripts must be removed after the installation is complete!';
localization['label.plsRemoveInstall'] =
'Please contact system administrator to finalize the webhelp installation by removing the installation folder!';
localization['configInvalid'] = 'Invalid config File - run install first!';
localization['webhelp.content'] = 'Content';
localization['oldFrames'] = 'With Frames';
localization['IndexFilterPlaceholder'] = 'Filter Index Entries';
localization['SearchResults'] = 'Search Results';
localization['Loading, please wait ...'] = 'Loading, please wait ...';
localization['Search no results'] = 'Your search returned no results for';
localization['There is no page containing all the search terms.'] =
'There is no page containing all the search terms.';
localization['Partial results:'] = 'Partial results:';
localization['Search string can\'t be void'] = 'Search string can\'t be void';
localization['Search string must have at least two characters'] = 'Search string must have at least two characters';
localization['Only first 10 words will be processed.'] = 'Only first 10 words will be processed.';
localization['Your browser is not supported. Use of Mozilla Firefox is recommended.'] =
'Your browser is not supported. Use of Mozilla Firefox is recommended.';
localization['linkToThis'] = 'Link to this page';
localization['ExpandAll'] = 'Expand All Topics';
localization['printThisPage'] = 'Print this page';
localization['CollapseAll'] = 'Collapse All Topics';
localization['label.confirmOk'] = 'Completed successful!';
localization['label.currentPwd'] = 'Current Password';
localization['label.Unsaved'] = 'Any unsaved data will be lost if you leave this page.';
localization['label.captcha'] = 'Enter the captcha code seen below:';
localization['label.welcome'] = 'Welcome';
localization['label.close'] = 'Close';
localization['label.cancel'] = 'Cancel';
localization['label.logAdmin'] = 'Log in as \'Moderator\' user';
localization['label.guest'] = 'Guest';
localization['label.admin'] = 'Admin';
localization['label.administrator'] = 'Administrator';
localization['label.admin.title'] = 'Administrative Page';
localization['label.moderator'] = 'Moderator';
localization['label.user'] = 'User';
localization['label.userProfile'] = 'User Profile';
localization['noDataAvailable'] = 'No data available';
localization['label.yourName'] = 'Your Name';
localization['label.yourEmail'] = 'Your email address';
localization['label.IwantEmail'] = 'I want to receive an email when';
localization['label.commentPage'] = 'a comment is left on a page that I commented on';
localization['label.commentTopic'] = 'a comment is left on any topic in the Help system';
localization['label.commentMy'] = 'a reply is left to one of my comments';
localization['label.apply'] = 'Apply Changes';
localization['label.newPwd'] = 'New Password';
localization['label.reNewPwd'] = 'Retype New Password';
localization['label.chPwd'] = 'Change Password';
localization['label.comments'] = 'Comments';
localization['label.login'] = 'Log in';
localization['label.signUp'] = 'Sign Up';
localization['label.edit'] = 'Edit';
localization['label.editAccount'] = 'Edit Account';
localization['label.logOff'] = 'Log Off';
localization['label.approveAll'] = 'Approve All';
localization['label.yes'] = 'Yes';
localization['label.no'] = 'No';
localization['label.addNewCmt'] = 'Add New Comment';
localization['label.plsWait'] = 'Please Wait ...';
localization['label.plsWaitChProfile'] = 'Loading User Profile ...';
localization['label.plsWaitRecover'] = 'Recovering Password ...';
localization['label.plsWaitSignUp'] = 'Signing you up ...';
localization['label.plsWaitUpProfile'] = 'Updating Your Profile ...';
localization['label.plsWaitUpPaswd'] = 'Updating your Password ...';
localization['label.plsWaitCmts'] = 'Loading Comments ...';
localization['label.plsWaitAuth'] = 'Verifying User ...';
localization['label.insertCmt'] = 'Insert Comment';
localization['label.submit'] = 'Submit';
localization['label.userName'] = 'User name';
localization['label.pswd'] = 'Password';
localization['label.lostPswd'] = 'Lost Password';
localization['label.signUp_userName'] = 'Choose a user name';
localization['label.signUp_email'] = 'Your Email Address';
localization['label.signUp_name'] = 'Your Name';
localization['label.signUp_password'] = 'Password';
localization['label.signUp_rPassword'] = 'Retype Password';
localization['label.recoverPwd'] = 'Reset Password';
localization['label.recoverEmail'] = 'Your Email Address';
localization['label.recoverUser'] = 'Your User Name';
localization['label.bt_recover'] = 'Reset Password';
localization['label.question'] = 'Are you sure you want to delete this message?';
localization['label.adminPanel'] = 'Admin Panel';
localization['label.changesNotApplied'] = 'Changes were not applied!';
localization['label.search.user'] = 'Search User Information';
localization['label.editUser'] = 'Edit User';
localization['label.updateUser'] = 'Update User';
localization['label.created'] = 'Created';
localization['label.validated'] = 'Validated';
localization['label.suspendend'] = 'Suspended';
localization['label.back'] = 'Back';
localization['label.setVersion'] = 'Set Version';
localization['label.export'] = 'Export Comments';
localization['label.confirm.bt'] = 'Confirm';
localization['label.selection'] = 'Selected Product / Version';
localization['label.version'] = 'Comments Version';
localization['label.versionInfo'] = 'The comments are visible starting from version:';
localization['label.rememberme'] = 'Remember me on this computer';
localization['label.viewAllPosts'] = 'View All Posts';
localization['label.allPosts'] = 'All Posts';
localization['label.forView'] = 'Select Product and Version to View Comments';
localization['label.forExport'] = 'Select Product and Version to Export Comments';
localization['label.product'] = 'Product';
localization['label.confirmGo'] = 'OK';
localization['delete'] = 'Delete';
localization['checkUser.1'] = 'Anonymous user does not validate please contact system administrator!';
localization['checkUser.2'] = '';
localization['checkUser.3'] = '';
localization['checkUser.4'] = '';
localization['checkUser.loginError'] = 'Log in failed!';
localization['info.noComments'] = 'There are no comments!';
localization['invalidCode'] = 'Please insert the specified captcha code';
localization['pwd.invalid'] = 'Invalid password';
localization['pwd.repeat'] = 'Please insert the same password!';
localization['pwd.empty'] = 'Please insert a minimum 5 characters password!';
localization['checkEmail-signUp'] = 'Please check your e-mail and validate your registration!';
localization['checkEmail-recover'] = 'Please check your e-mail for recovered password!';
localization['recoveryConfirmation'] = 'Your new password has been generated, please check your e-mail';
localization['editPost'] = 'Edit Comment';
localization['newPost'] = 'Insert Comment';
localization['admin'] = 'Administrator';
localization['moderator'] = 'Moderator';
localization['user'] = 'User';
localization['created'] = 'Created';
localization['validated'] = 'Validated';
localization['suspended'] = 'Suspended';
localization['label.adminComments'] = 'Comments';
localization['label.adminUsers'] = 'Users';
localization['logAdmin'] = 'Please authenticate with moderator credentials!';
localization['approveAllConfirmation'] = 'Approve all comments?';
localization['signUp.confirmOk'] = 'Confirmation successful!';
localization['signUp.invalidPswd'] = 'Invalid password supplied !';
localization['signUp.confirmUsr'] = 'User creation was successful confirmed!';
localization['signUp.invalidUsr'] = 'Invalid user specified to be confirmed!';
localization['signUp.userConfirmed'] = 'Your user has been already confirmed!';
localization['signUp.err.0'] = 'User creation has succeeded!';
localization['signUp.err.1'] = 'Password is too short!';
localization['signUp.err.2'] = 'Password contain invalid characters!';
localization['signUp.err.3'] = 'Invalid e-mail address!';
localization['signUp.err.4'] = 'User name is already taken!';
localization['signUp.err.5'] = 'Email is already in the database!';
localization['signUp.err.6'] = 'Please insert a valid user name!';
localization['signUp.err.6.info'] =
'User name must contain only alphanumeric characters without spaces and it must be at least 2 character long';
localization['signUp.err.9'] = 'Invalid Sign Up data!';
localization['signUp.err.10'] = 'User can not be created!';
localization['pwd.tooShort'] = 'Password must be at least 5 characters long!';
localization['admin.name.label'] = 'Name';
localization['admin.status.label'] = 'Status';
localization['admin.email.label'] = 'E-Mail';
localization['admin.userName.label'] = 'User Name';
localization['admin.level.label'] = 'Level';
localization['admin.company.label'] = 'Company';
localization['admin.date.label'] = 'Date';
localization['admin.notifyPage.label'] = 'Page Notification';
localization['admin.notifyAll.label'] = 'WebHelp Notification';
localization['admin.notifyReply.label'] = 'Reply Notification';
localization['comment.moderate.info'] = 'Post waiting for approval.';
localization['inst.deploymentSett'] = 'Deployment Settings';
localization['inst.overConfig'] = 'Overwrite Configuration File ?';
localization['inst.title'] = 'WebHelp Installer';
localization['inst.url'] = 'Deployment URL';
localization['inst.email'] = 'WebHelp E-mail from';
localization['inst.errors'] = 'Send Errors to System Administrator';
localization['inst.adminEmail'] = 'System Administrator E-mail';
localization['inst.isModerated'] = 'Comment system is moderated?';
localization['inst.sesLife'] = 'Client Session lifetime (sec)';
localization['inst.isAnonymous'] = 'Is Anonymous post enable?';
localization['inst.dbSettings'] = 'Database Settings';
localization['inst.dbtype'] = 'Database Server Type';
localization['inst.dbCreate'] = 'Create new database ?';
localization['inst.dbHost'] = 'Database Host Name';
localization['inst.dbName'] = 'Database Name';
localization['inst.dbUser'] = 'Database User Name';
localization['inst.dbPass'] = 'Database User Password';
localization['inst.initSett'] = 'Initial Settings';
localization['inst.adminPass'] = 'Administrator Password';
localization['inst.adminPass2'] = 'Confirm Administrator Password';
localization['inst.start'] = 'Start Installation';
localization['inst.nextStep'] = 'Next Step';
localization['excluded.terms'] = 'Excluded terms:';

export default localization;
